// extracted by mini-css-extract-plugin
export default {"top":"socialIcons_top__Zf8Pu","name":"socialIcons_name__hg5rf","socialIcons":"socialIcons_socialIcons__DTvH8"};